'use strict';

import $ from 'jquery';
import 'slick-carousel';
import enquire from 'enquire.js';

export default class RelatedContent {
  constructor(config) {
    let $relatedCarousel = $('.related-content__list');

    let { breakpoints } = config;

    enquire.register(`screen and (max-width:${ breakpoints.tablet - 1 }px)`, {
      match: () => {
        $relatedCarousel.slick({
          infinite: false,
          dots: true,
          arrows: false,
          speed: 1000,
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '0px'
        });
      },
      unmatch: () => {
        $relatedCarousel.slick('unslick');
      }
    });
  }
}
